import request from "@/utils/request";

const api = {
  downloadUrl: "/system/app-upgrade/download", // 获取不同手机类型下载App 的链接地址
  iosDownloadUrl: "/system/apple-business/redemption", // ios下载url 获取手机号码
  uploadImg: "/system/upload/upload", // 上传图片url
  idCardFrontOCR: "/system/orc/idcard-front", // 身份证正面识别url
  cashierProducts: "/v2/insurance/store/cashier-products", // 根据门店id获取商品和门第信息url
  cashierReceiveCode: "/v2/insurance/receive-code/cashier", // 获取付款链接url
  cashierPay: "/payment/inside/cashierPay", // 付款url
};

/**
 * 下载
 * @param {*} parameter
 */
export function getDownloadUrl(parameter) {
  return request.get(api.downloadUrl, parameter);
}

/**
 * IOS下载
 * @param {*} parameter
 */
export function getDownloadUrlByPhone(parameter) {
  return request.get(api.iosDownloadUrl, parameter);
}

/**
 * 上传图片
 * @param {*} parameter
 */
export function uploadImg(parameter) {
  return request.post(api.uploadImg, parameter);
}

/**
 * 身份证正面识别
 * @param {*} parameter
 */
export function idCardFrontOCR(parameter) {
  return request.get(api.idCardFrontOCR, parameter);
}

/**
 * 根据门店id获取商品和门第信息
 * @param {*} parameter
 */
export function getCashierProducts(parameter) {
  return request.get(api.cashierProducts, parameter);
}

/**
 * 获取付款链接
 * @param {*} parameter
 */
export function cashierReceiveCode(parameter) {
  return request.post(api.cashierReceiveCode, parameter);
}
/**
 * 付款
 * @param {*} parameter
 */
export function cashierPay(parameter) {
  return request.get(api.cashierPay, parameter);
}
